var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_491_680)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2779 26.4727C16.8874 26.0821 16.668 25.5522 16.668 24.9998C16.668 24.4474 16.8874 23.9176 17.2779 23.5269L29.0634 11.7415C29.2555 11.5425 29.4854 11.3838 29.7396 11.2746C29.9938 11.1654 30.2671 11.108 30.5438 11.1055C30.8204 11.1031 31.0947 11.1559 31.3508 11.2606C31.6068 11.3654 31.8394 11.5201 32.035 11.7157C32.2306 11.9113 32.3853 12.1439 32.4901 12.3999C32.5948 12.6559 32.6475 12.9303 32.6451 13.2069C32.6427 13.4835 32.5853 13.7569 32.4761 14.0111C32.3669 14.2653 32.2082 14.4951 32.0092 14.6873L21.6967 24.9998L32.0092 35.3123C32.3887 35.7052 32.5987 36.2315 32.5939 36.7777C32.5892 37.324 32.3701 37.8465 31.9838 38.2328C31.5975 38.619 31.075 38.8381 30.5288 38.8429C29.9825 38.8476 29.4563 38.6376 29.0634 38.2582L17.2779 26.4727Z",
    fill: "#FDFDFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_491_680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/LeftArrow.83e093f1a54c97431417dfd8cf3daba3.svg";
export { ForwardRef as ReactComponent };